import React from "react";

export const Footer = () => {
    return (
        <footer>
            <div className="footerContainer">
                <p>&copy; Kristiina Kolu</p>
                <p>Technigo Boot Camp '22, week 10 project</p>
            </div>
        </footer>
    )
}